import { motion } from 'framer-motion';

const SvgComponent = ({ transition, ...props }) => (
    <motion.svg

        initial={{
            y: '30%',
            x: '10%',
            scale: 0.8,
            opacity: 0
        }}
        animate={{
            y: '8%',
            opacity: 1,
            scale: .9,
            transition: { ...transition }
        }}
        exit={{
            y: '30%',
            opacity: 0,
            transition: { ...transition }
        }}
        viewBox="0 0 316 290"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M250.669 125.607V200.745C250.669 208.889 243.698 215.557 235.183 215.557H224.3V249.999L188.289 215.557H90.0202C81.5047 215.557 74.5334 208.889 74.5334 200.745V180.392H158.155C166.676 180.392 173.642 173.73 173.642 165.58V110.795H235.183C243.698 110.795 250.669 117.457 250.669 125.607Z" fill="url(#paint0_linear_136_8917)" />
        <path d="M62.0443 179.67H61.6583V179.903L26.9995 214.969V180.056V179.67H26.6135H15.9066C7.74586 179.67 1.05572 172.913 1.05572 164.64V86.4384C1.05572 78.1708 7.74595 71.4085 15.9066 71.4085H158.728C162.498 71.4085 165.955 72.8507 168.583 75.2137C171.649 77.9764 173.579 81.9968 173.579 86.4384V107.621V164.64C173.579 172.913 166.894 179.67 158.728 179.67H62.0443Z" fill="url(#paint1_linear_136_8917)" stroke="url(#paint2_radial_136_8917)" stroke-width="0.772077" />
        <path opacity="0.2" d="M188.289 214.858H90.0202C81.5047 214.858 74.5334 207.658 74.5334 198.863V208.176C74.5334 216.971 81.5047 224.171 90.0202 224.171H188.289L224.3 261.363V252.05L188.289 214.858ZM235.183 214.858H224.3V224.171H235.183C243.698 224.171 250.669 216.971 250.669 208.176V198.863C250.669 207.658 243.698 214.858 235.183 214.858Z" fill="black" />
        <path opacity="0.2" d="M156.137 180.402H61.0382V180.408L26.1882 216.753V224.431L61.0382 188.087V188.081H156.137C164.383 188.081 171.124 181.051 171.124 172.451V164.772C171.124 173.372 164.383 180.402 156.137 180.402ZM26.1882 180.402H15.6568C7.41607 180.402 0.669678 173.372 0.669678 164.772V172.451C0.669678 181.051 7.41607 188.081 15.6568 188.081H26.1882V180.402Z" fill="black" />
        <path d="M244.986 77.5566L235.043 67.6135V59.659H230.072V54.6874C230.072 24.3607 201.236 0 165.441 0C129.646 0 100.81 24.3607 100.81 54.6874V59.659H95.8389V67.6135L85.8958 77.5566V101.42L95.8389 111.363V119.318H120.697V59.659H110.754V54.6874C110.754 43.2527 115.725 33.3096 124.177 25.3551L135.114 36.2925L138.595 33.8067C146.549 27.8408 155.498 24.8579 165.441 24.8579C175.384 24.8579 184.333 27.8408 192.288 33.8067L195.768 36.2925L206.705 25.3551C215.157 33.3096 220.128 43.2527 220.128 54.6874V59.659H210.185V119.318H220.128V129.261C220.128 137.713 213.665 144.176 205.214 144.176H190.299V139.204H140.583V159.091H190.299V154.119H205.214C219.134 154.119 230.072 143.182 230.072 129.261V119.318H235.043V111.363L244.986 101.42V77.5566Z" fill="url(#paint3_linear_136_8917)" />
        <defs>
            <linearGradient id="paint0_linear_136_8917" x1="188.248" y1="120.443" x2="163.134" y2="235.241" gradientUnits="userSpaceOnUse">
                <stop stop-color="#FFB800" />
                <stop offset="0.304219" stop-color="#FFCC49" />
                <stop offset="0.612485" stop-color="#FFE39A" />
                <stop offset="1" stop-color="white" />
            </linearGradient>
            <linearGradient id="paint1_linear_136_8917" x1="84.8416" y1="37.9057" x2="84.8416" y2="358.725" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E14FFE" />
                <stop offset="0.0625" stop-color="#E14FFE" />
                <stop offset="0.125" stop-color="#E04FFE" />
                <stop offset="0.1875" stop-color="#DD4FFE" />
                <stop offset="0.25" stop-color="#D84FFE" />
                <stop offset="0.3125" stop-color="#CF4FFE" />
                <stop offset="0.375" stop-color="#C250FE" />
                <stop offset="0.4375" stop-color="#AF50FE" />
                <stop offset="0.5" stop-color="#9751FF" />
                <stop offset="0.5625" stop-color="#7F51FF" />
                <stop offset="0.625" stop-color="#6C51FF" />
                <stop offset="0.6875" stop-color="#5F52FF" />
                <stop offset="0.75" stop-color="#5652FF" />
                <stop offset="0.8125" stop-color="#5152FF" />
                <stop offset="0.875" stop-color="#4E52FF" />
                <stop offset="0.9375" stop-color="#4D52FF" />
                <stop offset="1" stop-color="#4D52FF" />
            </linearGradient>
            <radialGradient id="paint2_radial_136_8917" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(0.669678 215.909) rotate(-39.8978) scale(167.822 165.167)">
                <stop offset="0.17255" stop-color="white" stop-opacity="0.6" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </radialGradient>
            <linearGradient id="paint3_linear_136_8917" x1="109.465" y1="140.444" x2="226.021" y2="12.814" gradientUnits="userSpaceOnUse">
                <stop stop-color="white" />
                <stop offset="1" stop-color="white" stop-opacity="0" />
            </linearGradient>
        </defs>
    </motion.svg>
)

export default SvgComponent
